import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import SimpleBar from "simplebar-react";
//i18n
import { withNamespaces } from "react-i18next";
import moment from "moment";
import { getLink } from "../../routes/getNotificationRoute";

const NotificationDashboard = (props) => {

  const role = localStorage.getItem("role");
  const store_type = localStorage.getItem("store_type");

  return (
    <>
      {" "}
      <Card>
        <CardBody>
          <CardTitle>Notifications</CardTitle>
          <Row>
            <Col lg={12}>
              {props.data.notifications &&
              props.data.notifications.length > 0 ? (
                <>
                  <SimpleBar style={{ height: "330px" }}>
                    {props.data.notifications &&
                      props.data.notifications.map((notification, ind) => {
                        return (
                          <Link
                            key={ind + 1}
                            to={() => {
                              return getLink(notification.action,role,store_type);
                            }}
                            className="text-reset notification-item"
                          >
                            <div className="media">
                              <div className="avatar-xs mr-3">
                                <span className="avatar-title bg-primary rounded-circle font-size-16">
                                  <i className="bx bx-cart"></i>
                                </span>
                              </div>
                              <div className="media-body">
                                <h6 className="mt-0 mb-1">
                                  {notification.title}
                                </h6>
                                <div className="font-size-12 text-muted">
                                  <p className="mb-1">{notification.body}</p>
                                  <p className="mb-0">
                                    <i className="mdi mdi-clock-outline"></i>{" "}
                                    {moment(notification.createdAt).fromNow()}{" "}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Link>
                        );
                      })}
                  </SimpleBar>
                  {props.viewAll && (
                    <div className="p-2 border-top d-grid text-center">
                      <Link
                        className="btn btn-sm btn-link font-size-14 text-center"
                        to="/notifications"
                      >
                        <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
                        <span key="t-view-more">{props.t("View All")}</span>
                      </Link>
                    </div>
                  )}
                </>
              ) : (
                <SimpleBar style={{ height: "80px" }}>
                  <Link to="" className="text-reset notification-item">
                    <div className="media">
                      <div className="media-body">
                        {/* <h6 className="mt-0 mb-1"></h6> */}
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">There are no notifications.</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </SimpleBar>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default withNamespaces()(NotificationDashboard);
